<h2 mat-dialog-title>{{ 'SEND_MESSAGE_DIALOG.CHOOSE_RECIPIENT' | translate }}</h2>
<mat-dialog-content>
  <ng-container *ngIf="loading$ | async; else showRecipients">
    <glxy-loading-spinner
      [size]="'large'"
      [fullWidth]="true"
      [fullHeight]="true"
      [inline]="false"
    ></glxy-loading-spinner>
  </ng-container>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-stroked-button (click)="close()">{{ 'PROJECT_TRACKER.CANCEL' | translate }}</button>
  <ng-container>
    <button mat-flat-button [disabled]="!selectedOrg" color="primary" (click)="sendMessage()">
      {{ 'SEND_MESSAGE_DIALOG.MESSAGE' | translate }}
    </button>
  </ng-container>
</mat-dialog-actions>

<ng-template #showRecipients>
  <glxy-form-field>
    <mat-radio-group (change)="selectOrg($event)">
      <ng-container *ngFor="let organization of organizations">
        <div class="row row-gutters recipient">
          <mat-radio-button class="col-xs-10" [value]="organization.id" [checked]="defaultSelection">
            {{ organization.name | async }}
            <ng-container *ngIf="organization?.address">
              <extended>{{ organization.address | glxyAddress }}</extended>
            </ng-container>
          </mat-radio-button>
          <div *ngIf="getConversationBadge(organization); let badge" class="col-xs-2 type-label">
            <glxy-badge [color]="badge.badgeColor">{{ badge.participantType | translate }}</glxy-badge>
          </div>
        </div>
      </ng-container>
    </mat-radio-group>
  </glxy-form-field>
</ng-template>
